<template>
    <!--<trend
        :data="retentionHistory.map((e) => e.teacher * 100)"
        :gradient="['#6fa8dc', '#42b983', '#2c3e50']"
        auto-draw
        smooth
    >
    </trend>-->
    <div>
        <apexchart
            height="225"
            :options="{
                grid: {
                    show: false,
                },
                fill: {
                    type: 'solid',
                },
                dataLabels: {
                    enabled: false,
                },
                chart: {
                    toolbar: {
                        show: false,
                    },
                    animations: {
                        enabled: false, //rendered,
                    },
                },
                stroke: {
                    curve: 'smooth',
                    width: 4,
                },
                legend: {
                    show: true,
                },
                markers: {
                    size: 0,
                },
                xaxis: {
                    categories: chartData.dates,
                    tickAmount: Math.min(chartData.dates.length / 2, 12),
                    labels: {
                        show: true,
                    },
                },
                yaxis: {
                    min: chartData.min ?? 0,
                    max: chartData.max ?? 100,
                    tickAmount: 1,
                    labels: {
                        show: true,
                        formatter: function (value) {
                            if (!chartData.percent) return value;
                            return value + '%';
                        },
                    },
                },
                colors: ['#228cbd', '#f38c68'],
            }"
            :series="chartData.series"
        ></apexchart>
        <div v-if="chartData.options?.length > 1">
            <v-row>
                <v-col class="flex justify-center">
                    <v-btn-toggle
                        v-model="selectOption"
                        mandatory
                        class="soli-round"
                        color="primary"
                    >
                        <v-btn
                            v-for="option in chartData.options"
                            :key="option.key"
                            :value="option.key"
                            small
                            :loading="option.loading"
                            class="text-capitalize"
                            ><v-icon
                                v-if="option.key == selectOption"
                                small
                                color="primary"
                                left
                                >check</v-icon
                            >
                            {{ option.display }}
                        </v-btn>
                    </v-btn-toggle>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        chartData: {
            type: Object,
            default: () => {},
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            selectOption: this.chartData.options
                ? this.chartData.options[0].key
                : null,
            rendered: false,
        };
    },
    mounted() {
        this.rendered = true;
    },
    watch: {
        selectOption(val) {
            this.chartData.options.find((e) => e.key == val).loading = true;
            this.$emit("selectOption", val);
        },
        loading(val) {
            if (!val) {
                this.chartData.options.forEach((e) => (e.loading = false));
            }
        },
    },
};
</script>
